import { AssetItemDto, AssetVersionItemDto } from '@api/Api';

export type CopiedCommentsData = {
  assetVersionId: string;
  commentIds: string[];
};

export interface IMediaViewerState {
  assets: AssetItemDto | null;
  selectedVersion: AssetVersionItemDto | null;
  isOpenTranscript: boolean | null;
  isAssetsSliderOpen: boolean;
  copiedComments: CopiedCommentsData | null;
}

export interface IMediaViewerAction {
  type: string;
  payload?: any;
}

export enum MediaViewerActionTypes {
  SET_ASSET = 'SET_ASSET',
  TOGGLE_ASSET_FAVORITE = 'TOGGLE_ASSET_FAVORITE',
  RENAME_ASSET_VERSION = 'RENAME_ASSET_VERSION',
  SET_SELECTED_VERSION = 'SET_SELECTED_VERSION',
  UPDATE_SELECTED_VERSION = 'UPDATE_SELECTED_VERSION',
  SET_RESET_ASSET_STATE = 'SET_RESET_ASSET_STATE',
  SET_TOGGLE_OPEN_TRANSCRIPT = 'SET_TOGGLE_OPEN_TRANSCRIPT',
  SET_ASSETS_SLIDER_OPEN = 'SET_ASSETS_SLIDER_OPEN',
  SET_COPIED_COMMENTS = 'SET_COPIED_COMMENTS'
}
